import React from "react";

export const CANAL_PAGO_VACIO = {
  canal_pago: "", banco_pago: "", tipo_cuenta_pago: "", nro_cuenta_pago: "",
  titular_cuenta_pago: "", doc_titular_pago: "", alias_pago: "",
};

export const CANALES_CON_BANCO = ["WEB", "CHEQUE", "TRANSFERENCIA"];

export const canalPagoDe = (obj) => ({
  canal_pago: obj?.canal_pago || "",
  banco_pago: obj?.banco_pago || "",
  tipo_cuenta_pago: obj?.tipo_cuenta_pago || "",
  nro_cuenta_pago: obj?.nro_cuenta_pago || "",
  titular_cuenta_pago: obj?.titular_cuenta_pago || "",
  doc_titular_pago: obj?.doc_titular_pago || "",
  alias_pago: obj?.alias_pago || "",
});

const inp = "w-full bg-arandu-dark border border-white/10 rounded-lg px-3 py-2 text-white text-sm focus:outline-none focus:border-blue-500/60";
const lbl = "text-slate-400 text-xs mb-1 block";

/**
 * Canal de pago de un gasto (que no tiene entidad) + datos de la cuenta bancaria
 * destino cuando el canal tiene vínculo con un banco (WEB / CHEQUE / TRANSFERENCIA).
 * Props: value (objeto con los 7 campos), onChange(patch)
 */
export default function CanalPagoGastoFields({ value, onChange }) {
  const v = value || CANAL_PAGO_VACIO;
  const set = (k, val) => onChange({ [k]: val });
  const conBanco = CANALES_CON_BANCO.includes(v.canal_pago);
  return (
    <div className="space-y-3">
      <div>
        <label className={lbl}>Canal de pago</label>
        <select value={v.canal_pago} onChange={(e) => set("canal_pago", e.target.value)} className={inp}>
          <option value="">Sin especificar</option>
          <option value="WEB">WEB</option>
          <option value="CHEQUE">CHEQUE</option>
          <option value="EFECTIVO">EFECTIVO</option>
          <option value="TRANSFERENCIA">TRANSFERENCIA</option>
        </select>
        <p className="text-slate-500 text-[11px] mt-1">Se muestra en la lista e impresión de Programación de Caja.</p>
      </div>
      {conBanco && (
        <div className="rounded-xl border border-white/10 bg-white/[0.03] p-3 space-y-3">
          <p className="text-slate-300 text-xs font-medium">Cuenta bancaria destino</p>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className={lbl}>Banco</label>
              <input value={v.banco_pago} onChange={(e) => set("banco_pago", e.target.value)} placeholder="Ej: Itaú, Continental…" className={inp} />
            </div>
            <div>
              <label className={lbl}>Tipo de cuenta</label>
              <select value={v.tipo_cuenta_pago} onChange={(e) => set("tipo_cuenta_pago", e.target.value)} className={inp}>
                <option value="">—</option>
                <option value="Cuenta corriente">Cuenta corriente</option>
                <option value="Caja de ahorro">Caja de ahorro</option>
              </select>
            </div>
            <div>
              <label className={lbl}>N° de cuenta</label>
              <input value={v.nro_cuenta_pago} onChange={(e) => set("nro_cuenta_pago", e.target.value)} className={inp} />
            </div>
            <div>
              <label className={lbl}>Alias (opcional)</label>
              <input value={v.alias_pago} onChange={(e) => set("alias_pago", e.target.value)} className={inp} />
            </div>
            <div>
              <label className={lbl}>Titular</label>
              <input value={v.titular_cuenta_pago} onChange={(e) => set("titular_cuenta_pago", e.target.value)} className={inp} />
            </div>
            <div>
              <label className={lbl}>RUC / CI del titular</label>
              <input value={v.doc_titular_pago} onChange={(e) => set("doc_titular_pago", e.target.value)} className={inp} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
